import { render, staticRenderFns } from "./FormDSL.vue?vue&type=template&id=38a39da1"
import script from "./FormDSL.vue?vue&type=script&lang=js"
export * from "./FormDSL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports